import { win } from "../../common/namespaces";
import { createProxy } from "./proxy/proxy.js";
import { configAsync, name } from "./proxy/proxyConfig.js";
import { createStore } from "./store/store.js";
import * as symbols from "./utils/symbols.js";

if (!win.otto)
  Object.defineProperty(win, name, {
    value: createProxy(createStore(name)[1], configAsync),
    writable: false,
    configurable: import.meta.env.SSR || import.meta.env.MODE === "test",
    enumerable: false,
  });

/*                                                         */
if (!Symbol.onexus)
  Object.defineProperty(Symbol, "onexus", {
    value: symbols,
    configurable: import.meta.env.SSR || import.meta.env.MODE === "test",
  });
